import React, { useState, useEffect, useRef } from "react";
import "./popular.css";
import { useNavigate } from "react-router-dom";
import { formatDate, stripHtml } from "../utility/utility";
let BlogAPIUrl = process.env.REACT_APP_BLOG_API_URL;


const Popular = ({blogs}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(1);
  const carouselRef = useRef(null);
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setSlidesToShow(3);
      } else if (width >= 640) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const maxIndex = blogs?.length - slidesToShow;
    if (currentIndex > maxIndex) {
      setCurrentIndex(Math.max(0, maxIndex));
    }
  }, [slidesToShow, currentIndex, blogs?.length]);

  const nextSlide = () => {
    const maxIndex = blogs.length - slidesToShow;
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, maxIndex));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <div className="popular-container-main">
      <div className="popular-container">
        <h1 className="popular-section-title">Popular</h1>

        <div className="popular-blog-carousel">
          <div
            className="popular-blog-carousel-inner"
            ref={carouselRef}
            style={{
              transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
            }}
          >
            {blogs?.map((post, index) => (
              <div
                key={post.id}
                className={`popular-blog-card popular-blog-card-${index + 1}`}
                style={{ flex: `0 0 ${100 / slidesToShow}%` }}
              >
                <div className="popular-blog-card-content" onClick={()=>navigate(`/blogs/${post?.slug}`,  { state: post?.id }  )} >
                  <img
                    src={
                      `${BlogAPIUrl}uploads/files/${post?.image}` ||
                      `/api/placeholder/600/400?text=Blog+${index + 1}`
                    }
                    alt={post.title}
                    className="popular-blog-image"
                  />
                  <div className="popular-blog-info">
                    <div className="popular-blog-meta">
                      <div className="popular-tbc-blog-author-date">
                        By {post?.author?.name} | {formatDate(post?.created_at)}
                      </div>
                    </div>
                    <h2 className="popular-blog-title"  >{stripHtml(post.heading)}</h2>
                    <p className="popular-blog-excerpt">{stripHtml(post.excerpt)}</p>
                    <div className="popular-blog-footer">
                      <p onClick={()=>navigate(`/blogs/${post?.slug}`,  { state: post?.id })} className="popular-read-more">
                        Read blog →
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="popular-btns">
        <button
          className="popular-carousel-arrow prev"
          onClick={prevSlide}
          disabled={currentIndex === 0}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button
          className="popular-carousel-arrow next"
          onClick={nextSlide}
          disabled={currentIndex >= blogs?.length - slidesToShow}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Popular;